/*
================================================================================
                    WPQ SESSION - BUSINESS LOGIC
================================================================================
PURPOSE: Manages Welder Procedure Qualification records and integrates with WI, WCS, WQC modules.

KEY BUSINESS RULES:
1. FILE OPERATIONS: Upload to ANY record with same WPQ_RecordNo updates ALL related records
2. LAST WELD DATE: When WI slip generated, updates ALL WPQ details with same WPQ_Process_Category + WelderId
3. QUALIFICATION VALIDITY: 178 days from wld_createdon, auto-calculated WPQ_Welder_ExpiresOn
4. DELETION: Validates WI usage, project linking, status before allowing deletion

WI INTEGRATION FIELDS (extracted by backend):
• WPQ_FM_Arc_transfermode[1].Range_Qualified[0] → WI_WPQ_FM_Arc_transfermode
• WPQ_FM_Product_Form[1].Range_Qualified[0] → WI_WPQ_FM_Product_Form  
• WPQ_Groove_610[1].Range_Qualified → WI_WPQ_610_Positions (>610mm pipes)
• WPQ_Groove_73to610[1].Range_Qualified → WI_WPQ_73to610_Positions (73-610mm)
• WPQ_Groove_73[1].Range_Qualified → WI_WPQ_73_Positions (<73mm pipes)
• WPQ_Process_Category → Process compatibility
• WPQ_BM_WTBM_Pno → P-Number compatibility

REPORT FIELDS:
• WQC_Process → "SMAW|GTAW|" (pipe-delimited)
• WQC_Type → "Manual|Semi-Auto|" (pipe-delimited)
• WQC_Pcat → "SMAW#Manual|GTAW#Semi-Auto|" (pipe-delimited)

DATA STRUCTURE:
• Header: PK=WPSType, SK=WelderId#RecordNo
• Detail: PK=WelderId#RecordNo, SK=Process#Type

================================================================================
*/

import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExportWPQ } from "../utility/data/export/GlobalExport";
import { Row, Col, Container } from "react-bootstrap";
import { UpdateRecord, getbyrecordno, deleteWPQRecord } from "../../Services/wpq_groove-services";
import { getAllWPQDetailsGridData, uploadwpqgridfile, getdetailsById } from "../../Services/wpq_details-service";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import { ImageUploadRenderer } from "../utility/grid/renderers/ActionRenderers/ImageUploadRenderer";
import axios from "axios";
import Pdf_DownloadWPQ from "./PDF/Pdf_DownloadWPQ";
import { getPresignedURL, deleteWPQFile } from "../../Services/Welder-services";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import { GridLoader } from "react-spinners";
import { Status } from "../utility/common/constants/CommonConstants";
import Toaster, { showError, showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { checkWPQProjectLinking } from "../../Services/WI-services";
import { ICONS } from "../utility/common/constants/icons";


const QualificationDueInRenderer1 = ({ data }) => {
  const [year, month, day] = data.WPQ_Welder_ExpiresOn.split("-");
  const today = new Date();
  const future = new Date(year, month - 1, day);
  const timeDifferenceInMilliseconds = future - today;
  const daysDifference = Math.ceil(timeDifferenceInMilliseconds / (1000 * 60 * 60 * 24));
  const result = daysDifference < 0 ? 0 : daysDifference;
  data.wpq_QualificationDueIn = result;
  return result;
};

const ImageUploadRenderer1 = ({ data, folderwpq, UpdateRecord, getPresignedURL, handleimage, Imgloading, setLoading, filteredResult, setFilteredResult }) => {
  const [, setImageObjectURL] = useState("");
  const [, setPreUrl] = useState([]);
  const [imageData] = useState([]);
  const [profile, setProfile] = useState("");
  const [progress, setProgress] = useState(0);
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [downloadloading, setdownloadLoading] = useState(false);

  // Create unique ref for this specific row
  const rowFileInputRef = useRef(null);

  const handleFile = useCallback(async (file, currentRowData) => {
    console.log('🎯 File upload triggered for row:', currentRowData.WPQ_WelderId, currentRowData.WPQ_RecordNo);
    setLoading(true);
    let res;

    try {
      // Validate file size
      const maxSize = 40 * 1024 * 1024;
      if (file.size > maxSize) {
        showWarning("File size exceeds the allowed limit. upto 40Mb is Allowed");
        return;
      }

      // // Validate file type
      // let uploadextension = file.name.split(".")
      // if (uploadextension[uploadextension.length - 1].toLowerCase() !== "pdf") {
      //   showWarning("Please Upload PDF file with .pdf extension");
      //   return;
      // }

      // Validate file type
      let uploadextension = file.name.split(".");
      if (uploadextension[1] !== "pdf") {
        showWarning("Please Upload PDF file and dot(.) is not allowed in between pdf name , only .pdf extension is allowed");
        return;
      }

      // Create renamed file
      let abc = new File([file], `${currentRowData.WPQ_WelderId}_${currentRowData.WPQ_RecordNo}.pdf`);
      setProfile(abc);

      const objectURL = URL.createObjectURL(abc);
      setImageObjectURL(objectURL);

      // Check if file already exists (original logic)
      const hasExistingFile = currentRowData.WPQ_DocImage && currentRowData.WPQ_DocImage !== "";

      // Prepare file metadata (don't modify currentRowData yet)
      const fileMetadata = {
        WPQ_DocImage: abc.name,
        WPQ_DocImageOriginal: file.name,
        WPQ_DocImageData: {
          pdfsize: file.size.toString(),
          pdfname: abc.name,
          pdftype: file.type
        }
      };

      let result;

      // Original condition: only upload if no existing file
      if (!hasExistingFile) {
        // Create temporary row data for upload without modifying original
        const tempRowData = { ...currentRowData, ...fileMetadata };

        let startByte = 0;
        while (startByte < file.size) {
          const endByte = Math.min(startByte + chunkSize, file.size);
          result = await uploadFile(tempRowData, abc, res, startByte, endByte);
          startByte = endByte;
        }

        // FILE UPLOAD: Updates ALL records with same WPQ_RecordNo
        if (result) {
          const uploadData = {
            ...tempRowData,
            wld_WPSType: folderwpq === "WPQ_Groove" ? "Groove" : "Overlay"
          };

          let updateRecordResult = await uploadwpqgridfile(uploadData);

          // FRONTEND SYNC: Only update grid after successful database update
          if (updateRecordResult?.status) {
            setFilteredResult(prevResult =>
              prevResult.map(record =>
                record.PK === currentRowData.PK
                  ? { ...record, WPQ_DocImage: fileMetadata.WPQ_DocImage, WPQ_DocImageOriginal: fileMetadata.WPQ_DocImageOriginal }
                  : record
              )
            );
            showSuccess("File upload completed!");
          } else {
            showWarning("File upload failed");
          }
          setProgress(0);
        } else {
          showWarning("File upload failed. Please try again.");
        }
      }

    } catch (error) {
      console.error("File upload error:", error);
      showWarning("File upload failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [folderwpq, setLoading, setFilteredResult]);

  const handleDownload = useCallback(async (currentRowData) => {
    const result = await getPresignedURL(folderwpq, currentRowData.WPQ_DocImage);
    const geturl = result.url;

    setdownloadLoading(true);
    fetch(geturl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);

        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.target = "_blank";
        anchor.download = currentRowData.WPQ_DocImageOriginal;

        anchor.click();
        window.URL.revokeObjectURL(url);

        setdownloadLoading(false);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, [folderwpq, getPresignedURL]);

  const handleDeleteFile = useCallback(async (currentRowData) => {
    setLoading(true);

    try {
      // STEP 1: Update database first
      const updatedData = {
        ...currentRowData,
        WPQ_DocImageOriginal: "",
        WPQ_DocImage: "",
        WPQ_DocImageUrl: ""
      };

      console.log("Updating database record...");
      const dbResult = await UpdateRecord(updatedData);

      if (!dbResult?.status) {
        showWarning("Failed to update database record.");
        return;
      }

      console.log("Database updated successfully");

      // STEP 2: Update grid after successful database update
      setFilteredResult(prevResult =>
        prevResult.map(record =>
          record.WPQ_RecordNo === currentRowData.WPQ_RecordNo
            ? { ...record, WPQ_DocImage: "", WPQ_DocImageOriginal: "", WPQ_DocImageUrl: "" }
            : record
        )
      );

      // STEP 3: Delete S3 file after successful database update
      console.log("Deleting S3 file:", currentRowData.WPQ_DocImage);
      let filepath = `wld_Images/${folderwpq}`;
      const deleteResult = await deleteWPQFile(filepath, currentRowData.WPQ_DocImage);

      if (deleteResult?.status) {
        console.log("S3 file deleted successfully");
        showSuccess("File deleted successfully.");
      } else {
        console.log("S3 file deletion failed, but database already updated");
        showSuccess("File reference removed (S3 cleanup may be needed).");
      }

      setDeleteCounter(deleteCounter + 1);

    } catch (error) {
      console.error("Error deleting file:", error);
      showWarning("File deletion failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [UpdateRecord, setLoading, setFilteredResult, deleteCounter, folderwpq]);

  const chunkSize = 10000 * 10000;
  let uploadedBytes = 0;

  const uploadFile = async (row, abc, res, start, end) => {
    const chunk = profile.slice(start, end);
    const formData = new FormData();
    formData.append("chunk", chunk);
    formData.append("filename", profile.name);

    const result = await getPresignedURL(folderwpq, row.WPQ_DocImage);
    setPreUrl(result);
    row.WPQ_DocImageUrl = result.url;
    const posturl = result.url;
    let s3UploadResult;
    try {
      s3UploadResult = await axios.put(posturl, abc, {
        onUploadProgress: (progressEvent) => {
          uploadedBytes += progressEvent.loaded;
          const completed = Math.min(
            100,
            Math.round((uploadedBytes / end) * 100)
          );
          setProgress(completed);
        },
      });
    } catch (error) {
      console.error("Error uploading chunk : ", error);
    }
    return s3UploadResult;
  };

  return (
    <ImageUploadRenderer
      Imgloading={Imgloading}
      downloadloading={downloadloading}
      setdownloadLoading={setdownloadLoading}
      key={`upload-${data.PK}-${data.SK}-${deleteCounter}`}
      imageData={imageData}
      progress={progress}
      PreviewUrl={data.WPQ_DocImageUrl}
      profileOg={data.WPQ_DocImageOriginal}
      id={`fileUpload_${data.PK}_${data.SK}`}
      name="fileInput"
      type="file"
      accept="application/pdf"
      ref={rowFileInputRef}
      selectedData={{ data }}
      handleFile={(e) => {
        console.log('📁 File input changed for:', data.WPQ_WelderId, data.WPQ_RecordNo);
        if (e.target.files[0]) {
          handleFile(e.target.files[0], data);
        }
      }}
      handleDownload={() => handleDownload(data)}
      handleDelete={() => handleDeleteFile(data)}
      handleimage={() => handleimage(data)}
      filteredResult={filteredResult}
    />
  );
};


const WPQGroove_Overlay = forwardRef((props, ref) => {
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [Groove, setGroove] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  let folderwpq = "WPQ_Groove"
  let userprofile = sessionStorage.getItem("UserProfile");
  const [WPStype] = useState(props.type);
  const [userObj, setuserObj] = useState("");
  const [loading, setLoading] = useState(true);
  const [Imgloading, setImgLoading] = useState(false); // Loading state for image operations useState(true);
 
  const childRef = useRef();
  const year = new Date().getFullYear()


  let Band = sessionStorage.getItem("Band");

  const tmpcolumnDefs = [
    {
      headerName: "Status",
      field: "WPSH_Status",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "WPSCellRenderer",
      sort: "desc",
      minWidth: 200
    },
    {
      headerName: "Welder ID",
      field: "WPQ_WelderId",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Welder Name",
      field: "WPQ_WelderName",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Last Weld Date",
      field: "wld_createdon",
      type: "Date",
      isCheckbox: false,
      cellRenderer: "dateCellRenderer",
      filterParams: "filterDate",
    },
    {
      headerName: "WPQ Record No.",
      field: "WPQ_RecordNo",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },

    {
      headerName: "Process",
      field: "WPQ_Process",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      // floatingFilter: false,
      // suppressFilter: true,
    },
  ];


  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchGroove = async () => {
    const startYear = parseInt(process.env.REACT_APP_START_YEAR) || 2023;
    const currentYear = new Date().getFullYear();
    let allResults = [];
    const BATCH_SIZE = 2000;

    setLoading(true);

    try {
      // Create array of years in descending order
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
      }

      // Fetch all years in parallel, each handling its own pagination
      const yearPromises = years.map(async (year) => {
        let yearResults = [];
        let lastEvaluatedKey = null;
        let batchCount = 0;

        do {
          batchCount++;
          console.log(`📦 Fetching batch ${batchCount} for year ${year}`);

          const batch = await getAllWPQDetailsGridData({
            WPStype,
            selectedYear: year,
            limit: BATCH_SIZE,
            lastEvaluatedKey
          });

          yearResults = [...yearResults, ...batch.items];
          lastEvaluatedKey = batch.lastEvaluatedKey;

          console.log(`✅ Year ${year} batch ${batchCount}: ${batch.items.length} records`);

        } while (lastEvaluatedKey);

        console.log(`🎯 Year ${year} complete: ${yearResults.length} total records`);
        return yearResults;
      });

      // Wait for all years to complete
      const yearResults = await Promise.all(yearPromises);
      
      // Combine results maintaining year order
      allResults = yearResults.flat();

      // Final sort
      allResults.sort((a, b) =>
        a.WPQ_RecordNo.localeCompare(b.WPQ_RecordNo) ||
        a.WPQ_WelderId.localeCompare(b.WPQ_WelderId)
      );

      // Pre-compute Qualification Due In for proper sorting
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      allResults.forEach((record) => {
        if (record.WPQ_Welder_ExpiresOn) {
          const [year, month, day] = record.WPQ_Welder_ExpiresOn.split("-");
          const future = new Date(year, month - 1, day);
          const daysDifference = Math.ceil((future - today) / (1000 * 60 * 60 * 24));
          record.wpq_QualificationDueIn = daysDifference < 0 ? 0 : daysDifference;
        } else {
          record.wpq_QualificationDueIn = 0;
        }
      });

      setFilteredResult(allResults);
      setGroove(allResults);

      console.log(`🎉 All data loaded: ${allResults.length} total records`);

    } catch (error) {
      console.error("Error fetching WPQ data:", error);
      showError("Failed to load WPQ data");
    } finally {
      setLoading(false);
    }
  };

  const qualificationRenderer = (params) => (
    <QualificationDueInRenderer1 data={params.data} />
  );

  const imageRenderer = (params) => (
    <ImageUploadRenderer1
      data={params.data}
      folderwpq={folderwpq}
      UpdateRecord={UpdateRecord}
      getPresignedURL={getPresignedURL}
      handleimage={handleimage}
      Imgloading={Imgloading}
      setLoading={setLoading}
      filteredResult={filteredResult}
      setFilteredResult={setFilteredResult}
    />
  );

  const fetchColumnDefns = () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result.push({
      headerName: "Qualification Due In (Days)",
      field: "wpq_QualificationDueIn",
      cellRenderer: qualificationRenderer,
      comparator: (a, b) => (Number(a) || 0) - (Number(b) || 0),
      minWidth: 200,
    });
    result.push({
      headerName: "WPQ Documents",
      field: "WPQ_DocImageOriginal",
      cellRenderer: imageRenderer,
      minWidth: 250,
    });
    result.push({
      headerName: "",
      cellRenderer: actionRenderer,
      minWidth: 250,
      suppressMenu: true,
      sortable: false,
    });
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchGroove();
    fetchColumnDefns();
  }, []);

  function handleClick() {
    if (WPStype === "Groove") {
      navigate("/wpq/Groove/Groovetrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Overlay") {
      navigate("/wpq/Overlay/Overlaytrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    } else if (WPStype === "Tubesheet") {
      navigate("/wpq/TubetoTubesheet/TubetoTubesheettrans", {
        state: { data: "", action: "Add", WPStype: WPStype },
      });
    }
  }

  async function handleClickedit(row) {
    setLoading(true);
    try {
      // Fetch specific header record using deatils data in grid
      const headerData = await getbyrecordno(
        WPStype,
        row.WPQ_WelderId,
        row.WPQ_RecordNo
      );
      if (!Array.isArray(headerData) || headerData.length === 0) {
        showError("No record found for editing.");
        return;
      }
      const data = headerData[0];
      if (WPStype === "Groove") {
        navigate("/wpq/Groove/Groovetrans", {
          state: {
            data: data,
            action: "Edit",
            WPStype: WPStype,
            WPS_Change_No: data.WPS_Change_No,
          },
        });
      } else if (WPStype === "Overlay") {
        navigate("/wpq/Overlay/Overlaytrans", {
          state: {
            data: data,
            action: "Edit",
            WPStype: WPStype,
            WPS_Change_No: data.WPS_Change_No,
          },
        });
      } else if (WPStype === "Tubesheet") {
        navigate("/wpq/TubetoTubesheet/TubetoTubesheettrans", {
          state: {
            data: data,
            action: "Edit",
            WPStype: WPStype,
            WPS_Change_No: data.WPS_Change_No,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching header data : ", error);
      showError("Error loading record for edit.");
    } finally {
      setLoading(false);
    }
  }

  function handleClickTemp(row) {
    navigate("/wpq/Groove/Groovetrans", {
      state: { data: row, action: "Temp", WPStype: WPStype },
    });
  }
  useImperativeHandle(ref, () => ({
    handleAdd: () => {
      handleClick();
    },
  }));


  const handleGlobalSearch = (text) => {
    let searchText = text.toLowerCase();
    childRef.current.setSearch(searchText);
  };

  const handleGlobalExport = () => {
    if (WPStype === "Groove") {
      let filename = "WpqGrooveTransaction";
      handleExportWPQ(filteredResult, filename, columnDefs);
    } else if (WPStype === "Overlay") {
      let filename = "WpqOverlayTransaction";
      handleExportWPQ(filteredResult, filename, columnDefs);
    } else {
      let filename = "WpqTubesheetTransaction";
      handleExportWPQ(filteredResult, filename, columnDefs);
    }
  };

  const handlepdf = (row) => {
    if (row?.WPSH_Status === Status.StatusApproved || row?.WPSH_Status === Status.StatusPending) {
      setAction("pdf");
      setRowData(row);
      setShowForm(true);
      setuserObj(userprofile);
    } else {
      alert("Cannot Print PDF.Please Approve the Record")
    }

  };

  const handleDeleteRecord = async (row) => {
    setLoading(true);
    try {
      // DELETION VALIDATION: Check WI usage, project linking, status
      const wpqDetails = await getdetailsById(row.WPQ_WelderId, row.WPQ_RecordNo);

      // CHECK 1: WI usage (WI_WPQ_SlipGenerationStatus = "Yes")
      if (wpqDetails.some(item => item.WI_WPQ_SlipGenerationStatus === "Yes")) {
        showWarning("WPQ is already in use and cannot be deleted");
        return;
      }

      // CHECK 2: Project linking (WPQ_Linking + NpcilWpqLinking tables)
      const linkingResult = await checkWPQProjectLinking(row.WPQ_WelderId, row.WPQ_RecordNo);
      if (linkingResult?.isLinked) {
        showWarning("WPQ is linked to a project and cannot be deleted");
        return;
      }

      // CHECK 3: Status validation
      const allowedStatuses = [
        Status.StatusTempSaved,
        Status.StatusPending,
        Status.StatusRejected,
        Status.StatusApproved
      ];

      if (!allowedStatuses.includes(row?.WPSH_Status)) {
        showWarning("Cannot delete WPQ with current status.");
        return;
      }

      // DELETE: Cascade delete header + all detail records
      const deleteObj = {
        WPQ_WelderId: row.WPQ_WelderId,
        WPQ_RecordNo: row.WPQ_RecordNo,
        wld_WPSType: row.wld_WPSType,
        detailsPKSK: wpqDetails.map(item => ({ PK: item.PK, SK: item.SK }))
      };

      const result = await deleteWPQRecord(deleteObj);
      if (result?.status) {
        showSuccess(result.message);
        await fetchGroove(); // Refresh grid from server to reflect deletion
      } else {
        showError("Error!!! Not able to delete WPQ.");
      }
    } catch (error) {
      console.error("Error deleting WPQ  ", error);
      showError("Error!!! Not able to delete WPQ.");
    } finally {
      setLoading(false);
    }
  };

  async function handleClickcopy(row) {
    setLoading(true);
    try {
      // Fetch specific header record using deatils data in grid
      const headerData = await getbyrecordno(
        WPStype,
        row.WPQ_WelderId,
        row.WPQ_RecordNo
      );

      if (!Array.isArray(headerData) || headerData.length === 0) {
        showError("No record found for copying.");
        return;
      }

      if (WPStype === "Tubesheet") {
        navigate("/wpq/TubetoTubesheet/TubetoTubesheettrans", {
          state: { data: headerData[0], action: "Copy", WPStype: WPStype },
        });
      } else {
        navigate("/wpq/Groove/Groovetrans", {
          state: { data: headerData[0], action: "Copy", WPStype: WPStype },
        });
      }
    } catch (error) {
      console.error("Error fetching header data : ", error);
      showError("Error loading record for copy.");
    } finally {
      setLoading(false);
    }
  }

  const actionRenderer = (params) => {
    let actions = [];
    if (params.data.WPSH_Status === "Approved") {
      actions = ['delete', 'edit', 'export', 'copy', 'temp'];
    }
    else {
      actions = ['delete', 'edit', 'temp'];
    }

    return (
      <UnifiedActionRenderer
        actions={actions}
        selectedData={params}
        handleEditEvent={(params) => handleClickedit(params.data)}
        handlePdfEvent={(params) => handlepdf(params.data)}
        handleCopyEvent={(params) => handleClickcopy(params.data)}
        handleDeleteEvent={(params) => handleDeleteRecord(params.data)}
        handleTempEvent={(params) => handleClickTemp(params.data)}
      />
    );
  };

  const handleimage = (row) => {
    setRowData(row);
    setShowForm(true);
  };



  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Container fluid>

        <Row className="RowHeight">
          <Col md={2} sm={12} xs={12} className="ListTitle">
            WPQ Transaction list
          </Col>

          <Col>
            <div className="global-search-container">
              <GolbalSearch
                searchplaceholdertext={
                  "Search for " +
                  WPStype +
                  " WelderId, Welder Name ,Record No. , Revision No."
                }
                withYear={false}
                filterFunc={handleGlobalSearch}
              />
              <img
                className="allexport"
                src={ICONS.Export}
                alt="Export"
                onClick={handleGlobalExport}
              />
            </div>
          </Col>
        </Row>
        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          ref={childRef}
        />
        {showForm && (
          <Pdf_DownloadWPQ
            WPQtype={WPStype}
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            fetchUserMaster={fetchGroove}
            setReload={setReload}
            reload={reload}
            userObj={userObj}
            allRecs={Groove}
            backdrop="static"
            Band={Band}
          />
        )}
        <Toaster />
      </Container>
    </>
  );
});

export default WPQGroove_Overlay;